import { useEffect, useRef, useState } from "react";
import { useReveal } from "../lib/useReveal";

function Counter({ end, suffix = "" }) {
  const { ref, visible } = useReveal();
  const [val, setVal] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    if (!visible || started.current) return;
    started.current = true;
    const dur = 1400;
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      setVal(Math.floor(p * end));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [visible, end]);

  return (
    <div ref={ref} className="font-serif text-5xl sm:text-6xl md:text-7xl leading-none tracking-tight">
      {val}
      {suffix}
    </div>
  );
}

export default function Stats({ stats }) {
  if (!stats) return null;
  const items = [
    { label: "Biens vendus", value: stats.properties_sold },
    { label: "Années d'expérience", value: stats.years_experience },
    { label: "Clients satisfaits", value: stats.satisfaction, suffix: "%" },
    { label: "Biens en gestion", value: stats.managed },
  ];

  return (
    <section className="bg-[#1F2A36] text-white" data-testid="stats-section">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 md:px-12 lg:px-16 py-20 grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
        {items.map((s, i) => (
          <div key={s.label} className={`${i !== items.length - 1 ? "lg:border-r border-white/10 lg:pr-10" : ""}`}>
            <Counter end={s.value} suffix={s.suffix || ""} />
            <div className="mt-4 text-[12px] tracking-[0.22em] uppercase text-white/60">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
